module.exports = __webpack_public_path__ + "static/media/yoga-mit-kind.cd6f6b65.jpg";